export default function LastUsedBadge() {
  return (
    <span className="pointer-events-none absolute -top-2.5 right-2.5 inline-flex items-center gap-1 rounded-full border border-purple-200 bg-white px-2 py-1 text-[10px] leading-none font-semibold tracking-[0.08em] text-purple-700 uppercase shadow-[0_1px_2px_rgba(126,34,206,0.12)]">
      <span className="size-1 rounded-full bg-purple-500" />
      Last used
    </span>
  )
}
